<template>
    <div v-show="!loading">
        <div class="detail-wrapper">
            <div class="detail-title">
                    {{helpDetail.secondCategory}}
            </div>
            <div class="detail-content">
                <p>
                    {{helpDetail.content}}

                </p>

            </div>
            <div class="detail-footer">
                <div class="op like" @click="getHelpId()">
                    <span >有用</span>
                    <span>0</span>

                </div>
                <div class="op dislike" @click="getUnHelpId()">
                    <span  >无用</span>
                    <span>2</span>
                </div>

            </div>

        </div>
        <loading :show="loading"></loading>
    </div>
</template>

<script>
    import{

        helpDetail,
        helpBtnStatus,

    } from '../../../config/index'
    import {setStore,getStore} from "../../../assets/static/global/global";
    export default {
        name: "helpCenterDetail",
        data(){
            return{
                helpDetail:'',
                loading:true,
            }
        },
        methods:{
            async getHelpDetail(){
                this.loading=true;
                this.Id = getStore('helpDetail');
                let res = await helpDetail(String(this.Id));
                if(res.status){
                    this.loading=false;
                    this.helpDetail = res.data;
                    console.log(res.data);
                }else{
                    this.loading=false;
                }

            },
            async getHelpId(){
                let res = await helpBtnStatus(1,getStore('userId'));
                if(res.status){

                }


            },
            async getUnHelpId(){
                let res = await helpBtnStatus(0,getStore('userId'));
                if (res.status){

                }


            },
        },
        created() {
            this.getHelpDetail();
        }
    }
</script>

<style scoped lang="scss">
    .detail-wrapper {
        background: #f9fafc;
        padding: 20px;
        .detail-title {
            line-height: 24px;
            font-size: 18px;
            color: #000;
            font-weight: 700;
            margin-bottom: 20px;
        }
        .detail-content {
            font-size: 13px;

        }
        .detail-footer {
            padding: 24px 0;
            .like {
                background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAUlJREFUOBGlUrFKA0EQnbd3YGVjiFZyQhA1nWDlF/gFNjaW/oaFWPgJYmXpD1jYpPALFBFEIokQvEaMJrkk3o1vo9xC3DuILuzuzJs3b2dnF1Iw7pvxjkJOVWQYQA/XoqVzHxU+0GJ3zZcnbpG17TAGu+vR4sW351bjTGc9qM7Ry5NtJFM5dgxneQXSVrzlKD+Waq3dfluYxqGqwfNrrw6IGX1m0ThJxmkqR6K6+YtssC/QjmTyEc6Ht6uVShftuHvNRm0rl15/MJ1T6EPwLgZ7aMVdpgoPVAokhQm+AF/gJu/BRMXHKsH4zLVcgCWVUP0hZsS5gJ9SjvLWTgDyh0sA/+sBv3gjzIucsQUA0lRxlfcAbOmM47K+Uu0YKs18+UlOgBN7oK3gbAKwAH5nTtYCZJwpvTHjI8JDxgZ86T4Jj5wHG8vVhhX4Au44aK5uRZe8AAAAAElFTkSuQmCC) no-repeat 0 2px;
            }
             .op {
                float: right;
                margin-left: 40px;
                padding-left: 26px;
                font-size: 14px;
                color: #a7acb9;
                cursor: pointer;
            }
             .dislike {
                background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAT5JREFUOBGVU8FKAzEQnZm4pbhLQYSVQrEnoYL+gdCL3+FR/IEK0m8pePcjPOlJ8NY9iODS3ta92IOI7Y4zibAlW6oJS5L3kvdmkswi/LYsLy6Z+RqAuwggHyAzkAwoSDqdOz6Od4VABoaJboRsVgxhxfdiYLFy21oSx9ZKTdQVRDz6r9gZsx1Ug9O3QlLmmQDjFv/u40SOYE8j5zJYnYeIXeg6CK0YhzUMnxEwn4bLagXJ+6Q1DJ+R3GewgXsDF4ykHF5D464XCwHRWJ5kEWqi+6WQHq3ZS1l2lovliRRrAoxdrvi2YYj4bAyMo3Y7au1QzhxVvb3WdD0bq8nmH/v8/fnuGxDB2aB/8NDgfeK41yklt8a9mMP0yd+r2P0L3goh3HhUfoT45XEWbjQY9NM7Q3ChmchFzQnwapNYuR8AnFmWUeRRcAAAAABJRU5ErkJggg==) no-repeat 0 2px;
            }
        }
    }
</style>
